






























import Cart from '@/components/Cart.vue';
import EmailUs from '@/components/common/EmailUs.vue';
import ClinicsBasic from '@/graphql/queries/clinicsBasic.gql';
import request from '@/graphql/request';
import Vue from 'vue';
import Component from 'vue-class-component';

interface IClinicBasic {
  id: string;
  name: string;
  description: string;
  thumbnail: {
    url: string;
  };
}

@Component({
  components: {
    EmailUs,
  },
})
export default class Clinics extends Vue {
  public clinicsTitle: { name: string } = { name: 'CLINICS' };
  public subClinics: { name: string } = {
    name: 'Our clinics are proven safe and effective.',
  };
  public clinics: IClinicBasic[] = [];

  public mounted() {
    request(ClinicsBasic)
      .then(response => {
        if (!response || !response.data) {
          console.error('No clinics returned');
          return;
        }

        this.clinics = response.data.clinics;
      })
      .catch(console.error);
  }
}
